
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 1.05c-1.12 0-2 .872-2 1.912 0 1.041.88 1.913 2 1.913s2-.872 2-1.913c0-1.04-.88-1.912-2-1.912zM2.1 2.962C2.1 1.394 3.414.15 5 .15c1.586 0 2.9 1.244 2.9 2.813C7.9 4.53 6.586 5.774 5 5.774c-1.586 0-2.9-1.244-2.9-2.813zm4.5 4.819a9.83 9.83 0 00-3.2 0l-.124.02-.074-.443.074.444c-1.157.19-2.026 1.227-2.026 2.465 0 .391.303.683.647.683h6.206c.344 0 .647-.292.647-.683 0-1.238-.87-2.275-2.026-2.465l.074-.444-.074.444L6.6 7.78zm.146-.888l-.073.444.073-.444.125.02C8.482 7.18 9.65 8.61 9.65 10.268c0 .86-.679 1.583-1.547 1.583H1.897c-.868 0-1.547-.723-1.547-1.583 0-1.658 1.167-3.088 2.78-3.353l.124-.021.073.444-.073-.444c1.157-.19 2.335-.19 3.492 0z","fill":"currentColor"}})])
          )
        }
      }
    